import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'alert-component',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  imports: [MatIconModule],
})
export class AlertComponent {
  @Input() color?: 'error' | 'success';

  @Input() icon = '';

  @Input() message = '';
}
